export default "__VITE_ASSET__3b6bc326__"